import styled from 'styled-components'
import { Text } from '@lmc/ui-kit/src/general'
import { useTranslation } from 'react-i18next'
import { NAMESPACE } from 'locale'
import { FormCard } from '@lmc/ui-kit'
import dayjs from 'dayjs'
import { Avatar } from '@lmc/ui-kit'
import Divider from '@lmc/ui-kit/src/layout/Divider/Divider'

type CommentDetailContentProps = {
  record: any
  medicationName?: string
}

export const CommentDetailContent = ({ record }: CommentDetailContentProps) => {
  const { t } = useTranslation(NAMESPACE.EMAR_V2)

  const isEventRecord = record?.type === 'event'

  const description = isEventRecord
    ? Array.isArray(record?.notes)
      ? record.notes.join(', ')
      : record?.notes || ''
    : record?.description || record?.title || ''
  const recordedBy = isEventRecord ? record?.recordedBy : record?.loggedBy
  const recordedByName = recordedBy
    ? typeof recordedBy.name === 'object'
      ? `${recordedBy.name?.first || ''} ${recordedBy.name?.last || ''}`.trim()
      : recordedBy.name || ''
    : ''

  const timeLogged = isEventRecord
    ? record?.actionTime
      ? dayjs(record.actionTime).format('DD-MM-YYYY HH:mm')
      : record?.date
        ? dayjs(record.date).format('DD-MM-YYYY HH:mm')
        : '-'
    : record?.date
      ? dayjs(record.date).format('DD-MM-YYYY HH:mm')
      : '-'

  const witnesses = record?.witnesses || []

  return (
    <SectionContainer>
      <FormCard level={2}>
        <InfoRow>
          <FullWidthSection>
            <StyledLabel level={2}>{t('DESCRIPTION')}</StyledLabel>
            <Text>{description || '-'}</Text>
          </FullWidthSection>
        </InfoRow>
        <RowDivider />
        <InfoRow>
          <InfoSection>
            <StyledLabel level={2}>{t('TIME_RECORDED')}</StyledLabel>
            <Text>{timeLogged}</Text>
          </InfoSection>
          <InfoSection>
            <StyledLabel level={2}>{t('RECORDED_BY')}</StyledLabel>
            <RecordedByContainer>
              <Avatar
                url={recordedBy?.picture as unknown as string}
                size={16}
              />
              <Text>{recordedByName || '-'}</Text>
            </RecordedByContainer>
          </InfoSection>
          {record?.witnessed && witnesses.length > 0 && (
            <InfoSection>
              <StyledLabel level={2}>{t('WITNESSED_BY')}</StyledLabel>
              <Text weight="bold">
                {witnesses.length} {t('WITNESSES')}
              </Text>
            </InfoSection>
          )}
        </InfoRow>
      </FormCard>
    </SectionContainer>
  )
}

const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

const InfoRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 24px;
`

const InfoSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 184px;
`

const FullWidthSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

const StyledLabel = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color5};
`

const RowDivider = styled(Divider)`
  margin: -8px 0;
`

const RecordedByContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`
